export default __webpack_public_path__ + "static/urlshortner-9b85bb07815c9e4b41ee30b73a6c8321.gif";